"use client";

/**
 * Marketing homepage mobile nav (FQ-10).
 *
 * Below 768px, `SiteHeader`'s 4 primary links (How it works / Fees /
 * Pricing / Who it's for) are `hidden md:flex` with nothing to reveal them
 * — Lane A F-A-5 / Lane R F-R-04 confirmed zero hamburger and a 0×0
 * bounding box, meaning a phone visitor could never reach `/pricing` from
 * the header. This renders a hamburger that opens a full-screen drawer
 * with the same 4 links, on the same brand tokens as the rest of the page.
 * "Sign in" / "Request access" already render at every breakpoint in
 * `SiteHeader` and are unaffected.
 */

import { useState } from "react";
import Link from "next/link";

const NAVY = "#06172A";
const CREAM = "#F7F0E6";
const GOLD = "#B49664";

const PRIMARY_LINKS = [
  { href: "#how", label: "How it works" },
  { href: "#money", label: "Fees" },
  { href: "/pricing", label: "Pricing" },
  { href: "#for-whom", label: "Who it’s for" },
];

export function MobileNav() {
  const [open, setOpen] = useState(false);

  return (
    <div className="md:hidden">
      <button
        type="button"
        aria-label={open ? "Close navigation" : "Open navigation"}
        aria-expanded={open}
        aria-controls="mobile-nav-panel"
        onClick={() => setOpen((v) => !v)}
        className="relative z-50 ml-2 flex h-9 w-9 flex-col items-center justify-center gap-[5px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
        style={{ ["--tw-ring-color" as string]: GOLD, ["--tw-ring-offset-color" as string]: NAVY }}
      >
        <span
          aria-hidden="true"
          className="block h-px w-5 transition-transform duration-200"
          style={{ background: CREAM, transform: open ? "translateY(6px) rotate(45deg)" : "none" }}
        />
        <span
          aria-hidden="true"
          className="block h-px w-5 transition-opacity duration-200"
          style={{ background: CREAM, opacity: open ? 0 : 1 }}
        />
        <span
          aria-hidden="true"
          className="block h-px w-5 transition-transform duration-200"
          style={{ background: CREAM, transform: open ? "translateY(-6px) rotate(-45deg)" : "none" }}
        />
      </button>

      {open && (
        <div
          id="mobile-nav-panel"
          className="fixed inset-0 z-40 flex flex-col"
          style={{ background: "rgba(6,23,42,0.98)" }}
        >
          <nav
            aria-label="Primary (mobile)"
            className="flex flex-1 flex-col items-center justify-center gap-2 px-6"
          >
            {PRIMARY_LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-4 py-3 text-[22px] font-medium uppercase tracking-wide transition-opacity hover:opacity-80"
                style={{ color: CREAM, letterSpacing: "0.04em" }}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </div>
  );
}
